import React, { useEffect, useState } from 'react';
import './widgets.css'

export default function Widgets() {
    const [events, setEvents] = useState([])
    const [users, setUsers] =useState([])
    
    useEffect(() => {
        fetch('https://blood147.000webhostapp.com/admin_panel/readDonationPrograms.php')
        .then((resp) => resp.json())
        .then((event) => {
            setEvents(event.sort((a,b) => b.startDateTime - a.startDateTime).slice(0,5));
        })
        .catch((error) => console.log(error))
    }, []);

    useEffect(() => {
        fetch('https://blood147.000webhostapp.com/admin_panel/readUsers.php')
        .then((resp) => resp.json())
        .then((users) => {
            setUsers(users.sort((a,b) => b.userID - a.userID).slice(0,5))
        })
        .catch((error) => console.log(error))
    }, []);
    
    return (
        <div className="widgets">
            <div className="usersContainer">
                <div className="usersWrapper">
                    <div className="widgetsWrapper">
                        <h3>New Users</h3>
                        
                        <div className='listWrapper'>
                            <ul className='unorderedList'>
                                {users.map((item) => {
                                    return(
                                    <li className='item'>
                                        <p style={{color: '#0088FE'}}>{item.userName}</p>
                                        <p style={{color: '#FF8042'}}>{item.userBloodGroup}</p>
                                    </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="eventsContainer">
                <div className="eventsWrapper">
                    <div className="widgetsWrapper">
                        <h3>Upcoming Donation Events</h3>
                        
                        <div className='listWrapper'>
                            <ul className='unorderedList'>
                                {events.map((item) => {
                                    const start = item.startDateTime.split(/(\s+)/)
                                    return(
                                    <li className='item'>
                                        <p style={{color: '#0088FE'}}>{item.organizer}</p>
                                        <p style={{color: '#00C49F'}}>{start[0]}</p>
                                    </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
